module.exports = __webpack_public_path__ + "static/img/545_phase_function_Paper_PointsHejduk_Prediction.d9aa203.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/545_phase_function_Paper_PointsHejduk_Prediction.png
// module id = yQje
// module chunks = 0